export const CURSOR_STATES = {
  DEFAULT: 'default',
  COPY: 'copy',
  COPIED: 'copied'
} as const

export const CURSOR_IMAGES = {
  COPY: '/cursor-allowed-to-copy.svg',
  COPIED: '/cursor-clipboard-with-content.svg'
} as const
